import { Type } from 'class-transformer';
import {
  IsArray,
  IsDateString,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  ValidateNested,
} from 'class-validator';
import { BaseDto } from '../../@base/base.dto';
import { TicketId } from '../../types';
import { UserSummaryDto } from '../users/user-summary.dto';

export class TicketLinkDto {
  @IsString()
  @IsNotEmpty()
  linkType!: string;

  @IsNumber()
  @IsNotEmpty()
  zammadId!: number;

  @IsString()
  @IsOptional()
  ticketId?: string;
}

export class TicketArticleDto {
  @IsNumber()
  @IsNotEmpty()
  zammadId!: number;

  @IsString()
  @IsNotEmpty()
  body!: string;

  @IsString()
  @IsNotEmpty()
  sender!: string;

  @IsString()
  @IsNotEmpty()
  type!: string;

  @IsDateString()
  @IsNotEmpty()
  createdAt!: string;
}

export type TicketPriorityType = 'low' | 'normal' | 'high';

export class TicketZammadCustomerDto {
  @IsString()
  @IsOptional()
  firstname?: string;

  @IsString()
  @IsOptional()
  lastname?: string;

  @IsString()
  @IsOptional()
  email?: string;
}

export class TicketSummaryDto extends BaseDto<TicketId> {
  @IsNumber()
  @IsNotEmpty()
  zammadTicketId!: number;

  @ValidateNested()
  @Type(() => UserSummaryDto)
  @IsOptional()
  user?: UserSummaryDto;

  @ValidateNested()
  @Type(() => TicketZammadCustomerDto)
  @IsOptional()
  zammadCustomer?: TicketZammadCustomerDto;

  @ValidateNested()
  @Type(() => UserSummaryDto)
  @IsOptional()
  owner?: UserSummaryDto;

  @IsString()
  @IsNotEmpty()
  status!: string;

  @IsString()
  @IsOptional()
  priority?: TicketPriorityType;

  @IsString()
  @IsNotEmpty()
  subject!: string;

  @IsString()
  @IsOptional()
  body?: string;

  @IsDateString()
  @IsOptional()
  closedAt?: string;

  @IsNumber()
  @IsOptional()
  closeInMin?: number;

  @IsArray()
  @IsString({ each: true })
  @IsOptional()
  tags?: string[];

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => TicketLinkDto)
  @IsOptional()
  links?: TicketLinkDto[];

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => TicketArticleDto)
  @IsOptional()
  articles?: TicketArticleDto[];
}
